import { FETCH_SUMMARY_DATA, FETCH_GOOGLE_ANALYTICS_DATA } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchSummaryData = (startDate, endDate) => async (dispatch) =>
  await dispatch({
    type: FETCH_SUMMARY_DATA,
    message: "get data",
    payload: fetchService(
      `${baseUrl.backend}/api/stats?startDate=${startDate}&endDate=${endDate}`
    ),
  });

export const fetchGoogleAnalyticsData =
  (startDate, endDate) => async (dispatch) =>
    await dispatch({
      type: FETCH_GOOGLE_ANALYTICS_DATA,
      message: "get data",
      payload: fetchService(
        `${baseUrl.backend}/api/analytics?startDate=${startDate}&endDate=${endDate}`
      ),
    });
